import { KubitProgressBarSizeType, KubitProgressBarVariantType } from '../../variants';
import { commonStyles } from '../commonStyles';
import { ProgressBarComplexVariantType } from '../variants';
export const getProgressChartStyles = (FOUNDATIONS, FONT) => {
    return {
        [ProgressBarComplexVariantType.PROGRESS_CHART]: {
            ...commonStyles(FOUNDATIONS, FONT),
            kubitProgressBar: {
                variant: KubitProgressBarVariantType.PROGRESS_CHART,
                size: KubitProgressBarSizeType.DEFAULT,
            },
        },
    };
};
//# sourceMappingURL=progressChart.js.map